module.exports = __webpack_public_path__ + "img/chanpintedian.3f161cb2.png";